import { SimpleGrid, useMediaQuery } from '@chakra-ui/react'
import UserCard from './UseCard/UserCard'
import { User } from '../../types/types'

interface UserListProps {
    users: User[]
}

export function useDesktopMediaQuery() {
    const [isDesktop] = useMediaQuery('(min-width: 1230px)', {
        fallback: false,
    })
    return isDesktop
}


const UserList = ({ users }: UserListProps) => {
    const isDesktop = useDesktopMediaQuery()
    return (
        <SimpleGrid columns={[2, 3]} spacing={isDesktop ? 10 : 4}>
            {users.map((user) => (
                <UserCard key={user.userId} user={user} />
            ))}
        </SimpleGrid>
    )
}

export default UserList;
